export const mobileMenu = () => {
  $('.menu-toggle').click(function (e) {
    e.stopPropagation();
    $('body').toggleClass('mobile-menu-open');
    $(this).toggleClass('is-active');
  });
};
